export const FETCH_FABRICATION_JOBS = '@@fabrication/fetch-jobs';
export const FETCH_FABRICATION_JOBS_SUCCESS = '@@fabrication/fetch-jobs-success';
export const FETCH_FABRICATION_JOBS_FAILURE = '@@fabrication/fetch-jobs-failure';

export const CREATE_FABRICATION_JOB = '@@fabrication/create-job';
export const CREATE_FABRICATION_JOB_SUCCESS = '@@fabrication/create-job-success';
export const CREATE_FABRICATION_JOB_FAILURE = '@@fabrication/create-job-failure';

export const UPDATE_FABRICATION_JOB = '@@fabrication/update-job';
export const UPDATE_FABRICATION_JOB_SUCCESS = '@@fabrication/update-job-success';
export const UPDATE_FABRICATION_JOB_FAILURE = '@@fabrication/update-job-failure';

export const DELETE_FABRICATION_JOB = '@@fabrication/delete-job';
export const DELETE_FABRICATION_JOB_SUCCESS = '@@fabrication/delete-job-success';
export const DELETE_FABRICATION_JOB_FAILURE = '@@fabrication/delete-job-failure';
